import { useGetQuoteByQuoteReq } from "@/common/api/queries";
import { useTableContext } from "@/common/contexts/Table.context";
import NexPaginationButton from "@/components/Pagination/NexPaginationButton";
import PaginationButton from "@/components/Pagination/PaginationButton";
import PreviousPaginationButton from "@/components/Pagination/PreviousPaginationButton";
import { Pagination } from "antd";
import NewQuotesButton from "../NewQuotesButton";
import QuoteList from "../QuotesTable/QuoteList";
import { useEffect, useState } from "react";
import normalizeQuotesByQuoteReqId from "./normalizeQuotes";
import DownloadQuotesButton from "../DownloadQuotesButton/DownloadQuotesButton";
import { ResetFiltersButton } from "@/components";
import { usePermissions } from "@/common/contexts/Permissions.context";

export default function CustomerQuotes() {
  const { currentPage, filters, changePage, searchQ } = useTableContext();
  const [quoteToRender, setQuoteToRender] = useState<any[]>();
  const {isHavePermission} = usePermissions()
  const { data: customerQuotes } = useGetQuoteByQuoteReq(
    Number(currentPage * 10).toString(),
    filters,
    searchQ
  );
  useEffect(() => {
    if (!customerQuotes) return;
    setQuoteToRender(() => {
      return normalizeQuotesByQuoteReqId(customerQuotes.items);
    });
  }, [customerQuotes]);
  return (
    <div className="relative mt-10 w-full">
      <div>
        <QuoteList data={quoteToRender && quoteToRender} />
      </div>
      <div className="flex justify-between items-center mt-5">
        <div className="w-1/6"></div>
        {Boolean(customerQuotes && customerQuotes?.count > 10) && (
          <>
            <Pagination
              onChange={changePage}
              current={currentPage + 1}
              total={customerQuotes?.count || 1}
              defaultPageSize={10}
              className="pt-2"
              pageSize={10}
              align="center"
              showSizeChanger={false}
              itemRender={(page, type, originalElement) => {
                switch (type) {
                  case "next":
                    return <NexPaginationButton />;
                  case "prev":
                    return <PreviousPaginationButton />;
                  case "page":
                    return (
                      <PaginationButton current={currentPage + 1} page={page} />
                    );
                  default:
                    return originalElement;
                }
              }}
            />
            <DownloadQuotesButton />
          </>
        )}
      </div>
      {Boolean(customerQuotes?.count && customerQuotes?.count < 10) && (
        <div className="justify-self-end">
          <DownloadQuotesButton />
        </div>
      )}
      <div className="flex gap-5 absolute -top-5 right-0 -translate-y-1/4">
        <ResetFiltersButton />
       {isHavePermission('quotes_customer_create') && <NewQuotesButton />}
      </div>
    </div>
  );
}
